import { ClaimRequest, Fulfillment, PaymentMethod } from '@bybeam/platform-types';
import { PaymentRail } from '@platform-ui-common/utilities/paymentMethods.js';
import React, { useContext } from 'react';

export type ClaimPayload = Omit<ClaimRequest, 'id'>;

export interface ClaimState<T> {
  fulfillmentId: string;
  setMethod: (input: PaymentRail) => void;
  method?: Exclude<PaymentMethod, PaymentMethod.External>;
  setPayload: (input: Partial<T>) => void;
  payload?: Partial<T>;
  fulfillment?: Fulfillment;
  paymentRails?: PaymentMethod[];
  getNextPage: (method: Exclude<PaymentMethod, PaymentMethod.External>) => string;
}

// Only exported for use in tests/mocks; do NOT reference directly in prod code
export const ClaimContext = React.createContext<ClaimState<ClaimPayload>>(
  {} as ClaimState<ClaimPayload>,
);

export default function useClaim<T>(): ClaimState<T> {
  return useContext(ClaimContext);
}
